import { render, staticRenderFns } from "./BotaoNotificacao.vue?vue&type=template&id=74bd4a4a&scoped=true&"
import script from "./BotaoNotificacao.vue?vue&type=script&lang=js&"
export * from "./BotaoNotificacao.vue?vue&type=script&lang=js&"
import style0 from "./BotaoNotificacao.vue?vue&type=style&index=0&id=74bd4a4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bd4a4a",
  null
  
)

export default component.exports